import * as api from '../core/api/api';
import HttpMethods from '../enums/http-methods';

const fetchDictionaryRows = async <T>(searchParams: URLSearchParams) => {
  return await api.requestJSON<Accelerate.DictionaryRowData<T>>(
    `/dictionary/row/unrestricted/v2?${searchParams.toString()}`,
    {
      method: HttpMethods.GET
    }
  );
};

export { fetchDictionaryRows };
